import { setDeepProp, getDeepProp, isUndefined } from '../../utils/js.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable eqeqeq */
/**
 * Assegna alla proprietà props di obj il valore value.
 * Se la proprietà è annidata, lo stato dell'oggetto è copiato da stato.
 * @param props path della proprietà, ex: Dichiarativo.Messaggi[2]
 * @param value valore
 * @param obj oggetto di destinazione
 * @param stato stato iniziale
 */
const setProp = (props, value, obj, stato) => {
    setDeepProp(props, value, obj, stato);
};
/**
 * Return the value of a stato property by props path, or '' if the path doesn't exist.
 * props uses the dot notation to identity an object property or
 * [index] to identify an array item.
 * ex: Dichiarativo.Messaggi[2]
 * @param props return property path
 * @param stato source object where extract the value.
 */
function getProp(props, stato) {
    if (props === undefined) {
        return '';
    }
    const value = getDeepProp(props, stato);
    return isUndefined(value) ? '' : value;
}

export { getProp, setProp };
